<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Unidades de Autobus</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="showAddModal = true">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Unidad de Autobus</span>
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item.value"
                  :label="item.descripcion"
                  :value="Number(item.value)"
                >
                </el-option>
              </el-select>

              <div>
                <form class="apolo-borde">
                  <base-input
                    v-model="search"
                    type="search"
                    append-icon="fas fa-search"
                    placeholder="Buscar..."
                    clearable
                    inputClasses="apolo-borde"
                  />
                </form>
              </div>

              <el-select
                class="select-primary pagination-select"
                v-model="externo"
                placeholder="Externo/Rentado"
                clearable
              >
                <el-option
                  class="select-primary"
                  label="Si"
                  value="si"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  label="No"
                  value="no"
                >
                </el-option>
              </el-select>

              <el-select
                class="select-primary pagination-select"
                v-model="status"
                placeholder="Seleccionar status"
                clearable
              >
                <el-option
                  class="select-primary"
                  label="Activo/Inactivo"
                  value="Activo/Inactivo"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  label="Activo"
                  value="Activo"
                >
                </el-option>
                <el-option
                  class="select-primary"
                  label="Inactivo"
                  value="Inactivo"
                >
                </el-option>
              </el-select>
            </div>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="unidades"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>

              <div slot="empty" v-if="unidades">
                Sin datos disponibles
              </div>
  
              <el-table-column label="Layout" prop="attributes.layout.nombre" />
              <el-table-column label="Número economico" prop="attributes.numero_economico" />
              <el-table-column label="Placa" prop="attributes.placa" />
              <el-table-column label="Vigencia seguro">
                <div slot-scope="{ row }">
                  <span v-if="checkDate(row.attributes.vigencia_seguro)" style="color: red !important;">{{row.attributes.vigencia_seguro | moment('DD-MM-YYYY')}}</span>
                  <span v-else>{{row.attributes.vigencia_seguro | moment('DD-MM-YYYY')}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Es externo-rentado">
                <div slot-scope="{ row }">
                  <span v-if="row.attributes.externo_rentado">Si</span>
                  <span v-else>No</span>
                </div>
              </el-table-column>
              <el-table-column align="center">
                <div slot-scope="{ row }" class="table-actions">
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="editUnidad(row)">
                    <span class="btn-inner--text">Editar</span>
                  </base-button>
                  <base-button v-if="row.attributes.active" class="hover-apolo" type="primary" icon size="sm" @click="deactivateUnidad(row)">
                    <span class="btn-inner--text">Desactivar</span>
                  </base-button>
                  <base-button  v-else class="hover-apolo" type="primary" icon size="sm" @click="activateUnidad(row)">
                    <span class="btn-inner--text">Activar</span>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
      <!-- MODAL CREATE -->
      <modal :show.sync="showAddModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Crear unidad autobus</h6>
        <form class="new-event--form" @submit.prevent="addUnidad">
          <base-input label="Número económico"
                      placeholder="Número económico de unidad"
                      v-model="unidad.numero_economico"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.numero_economico" />
          <base-input label="Placa"
                      placeholder="Número de placa"
                      v-model="unidad.placa"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.placa" />
          <base-input label="Seleccione un layout">
            <multiselect v-model="unidad.layout" :options="layouts" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione un layout" track-by="id" label="nombre" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.layout" />
          <base-input label="Es externo-rentado?">
            <base-switch v-model="unidad.externo_rentado" class="mr-1"></base-switch>
          </base-input>
          <base-input v-if="unidad.externo_rentado" label="Empresa"
                      placeholder="Nombre de empresa"
                      v-model="unidad.empresa"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.empresa" />
          <br>
          <span>Seguro:</span>
          <base-input label="Póliza de seguro"
                      placeholder="Póliza de seguro"
                      v-model="unidad.poliza_seguro"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.poliza_seguro" />
          <base-input label="Compañía de seguro"
                      placeholder="Compañía de seguro"
                      v-model="unidad.compania_seguro"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.compania_seguro" />
          <base-input label="Vigencia de seguro">
            <date-picker
              v-model="unidad.vigencia_seguro"
              :format="'DD-MM-YYYY'"
              :lang="'es'"
            ></date-picker>
          </base-input>
          <validation-error :errors="apiValidationErrors.vigencia_seguro" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addUnidad">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL EDIT -->
      <modal :show.sync="showEditModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Editar unidad autobus</h6>
        <form class="new-event--form" @submit.prevent="updateUnidad">
          <base-input label="Número económico"
                      placeholder="Número económico de unidad"
                      v-model="unidad.numero_economico"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.numero_economico" />
          <base-input label="Placa"
                      placeholder="Número de placa"
                      v-model="unidad.placa"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.placa" />
          <base-input label="Seleccione un layout">
            <multiselect v-model="unidad.layout" :options="layouts" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecccione un layout" label="nombre" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.layout" />
          <base-input label="Es externo-rentado?">
            <base-switch v-model="unidad.externo_rentado" class="mr-1"></base-switch>
          </base-input>
          <base-input v-if="unidad.externo_rentado" label="Empresa"
                      placeholder="Nombre de empresa"
                      v-model="unidad.empresa"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.empresa" />
          <br>
          <base-input label="Póliza de seguro"
                      placeholder="Póliza de seguro"
                      v-model="unidad.poliza_seguro"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.poliza_seguro" />
          <base-input label="Compañía de seguro"
                      placeholder="Compañía de seguro"
                      v-model="unidad.compania_seguro"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.compania_seguro" />
          <base-input label="Vigencia de seguro">
            <date-picker
              v-model="unidad.vigencia_seguro"
              :format="'DD-MM-YYYY'"
              :lang="'es'"
            ></date-picker>
          </base-input>
          <validation-error :errors="apiValidationErrors.vigencia_seguro" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateUnidad">Actualizar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>
  <script>
  import Multiselect from 'vue-multiselect';
  import formMixin from "@/mixins/form-mixin";
  import ValidationError from "@/components/ValidationError.vue";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import { BasePagination, Modal, BaseSwitch } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      ValidationError,
      Modal,
      Multiselect,
      DatePicker,
      BaseSwitch,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },

    mixins: [formMixin],
  
    data() {
      return {
        unidades: [],
        layouts: [],
        selectedRows: [],

        externo: null,
        status: null,
        search: null,
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 unidades por página'},
          {value:'10', descripcion: '10 unidades por página'},
          {value:'25', descripcion: '25 unidades por página'},
          {value:'50', descripcion: '50 unidades por página'}],
        },
        total: 0,
        loading: true,
        showAddModal: false,
        showEditModal: false,
        unidad: {
          type: "unidad autobus",
          numero_economico: null,
          placa: null,
          layout: null,
          externo_rentado: false,
          empresa: null,
          poliza_seguro: null,
          compania_seguro: null,
          vigencia_seguro: null
        }
      };
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    watch: {
      search: {
        handler: "getListDebounced",
        immediate: true,
      },
      externo: {
        handler: "getListDebounced",
        immediate: true,
      },
      status: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
    },
    
    created(){
      this.getLayouts();
    },

    mounted(){
      //const date = new Date();
      //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    },
  
    methods: {
      checkDate(date){
        var now = new Date();

        var dateControl = date.split('-');
        dateControl = new Date(dateControl[0], dateControl[1]-1, dateControl[2]);
      
        if (dateControl < now 
            || (now.getMonth()+1) === (dateControl.getMonth()+1) && ((dateControl.getFullYear()) <= (now.getFullYear()))
            || ((dateControl.getMonth()+1)-(now.getMonth()+1)) === 1 && ((dateControl.getFullYear()) <= (now.getFullYear())) && ((dateControl.getDate()) - (now.getDate())) <= 0) {
          return true;
        } else {
          return false;
        }
      },
      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
  
      async getList() {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.search ? { search: this.search } : {}),
            ...(this.externo ? { externo: this.externo } : {}),
            ...(this.status ? { status: this.status } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
        await this.$store.dispatch("unidades/list", params).then(() => {
          this.unidades = this.$store.getters["unidades/list"];
          this.total = this.$store.getters["unidades/listTotal"];
        });
        this.loading = false;
      },

      async getLayouts(){
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
          },
          page: {
            number: 1,
            size: 10000,
          },
        };
        await this.$store.dispatch("layouts/listActive", params).then(() => {
          this.layouts = this.$store.getters["layouts/listActive"];
        });
      },

      closeModal() {
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showEditModal = false;
        }
        this.resetApiValidation();
        this.unidad.numero_economico = null;
        this.unidad.placa = null;
        this.unidad.layout = null;
        this.unidad.externo_rentado = false;
        this.unidad.empresa = null;
        this.unidad.poliza_seguro = null;
        this.unidad.compania_seguro = null;
        this.unidad.vigencia_seguro = null;
      },

      async addUnidad(){
        try {
        await this.$store.dispatch("unidades/add", this.unidad);
        this.$notify({
          type: "success",
          message: "Unidad creada satisfactoriamente.",
          duration: -1
        });
        this.getList();
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      editUnidad(row) {
        this.resetApiValidation();
        this.showEditModal = true;
        this.unidad.numero_economico = row.attributes.numero_economico;
        this.unidad.placa = row.attributes.placa;
        this.unidad.layout = this.layouts.find(item => item.id == row.attributes.layout.id);
        this.unidad.externo_rentado = row.attributes.externo_rentado;
        this.unidad.empresa = row.attributes.empresa;
        this.unidad.poliza_seguro = row.attributes.poliza_seguro;
        this.unidad.compania_seguro = row.attributes.compania_seguro;
        const date = row.attributes.vigencia_seguro.split('-');
        this.unidad.vigencia_seguro = new Date(date[0],date[1]-1,date[2]);
        this.unidad.id = row.id;
      },

      async updateUnidad() {
        try{
          await this.$store.dispatch("unidades/update", this.unidad);
          this.$notify({
            type: "success",
            message: "Unidad actualizada satisfactoriamente.",
            duration: -1
          });
          this.getList();
          this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },
      
      async activateUnidad(row) {
        const confirmation = await swal.fire({
          title: `¿Desea activar esta unidad?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Activar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("unidades/activate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Unidad activada satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },
      async deactivateUnidad(row) {
        const confirmation = await swal.fire({
          title: `¿Desea desactivar esta unidad?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Desactivar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
              await this.$store.dispatch("unidades/deactivate", row.id);
              await this.getList();
              this.$notify({
              type: "success",
              message: "Unidad desactivada satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        }
      },

      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>